import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ChangeLanguageSvg = function ChangeLanguageSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.606 3.499v3.044h4.323l-.069.821c-.201 2.421-1.473 4.672-3.34 6.296.753.562 1.659.931 2.607 1.003l.795.06-.126 1.517-.795-.06c-1.403-.106-2.72-.685-3.766-1.56-1.375.872-2.96 1.435-4.62 1.56l-.796.06-.126-1.517.796-.06a8.4 8.4 0 0 0 3.66-1.187c-.673-.898-1.109-1.955-1.2-3.068l-.064-.759 1.591-.12.063.76c.068.814.389 1.595.883 2.267 1.372-1.187 2.372-2.77 2.728-4.491H2.755V6.543H7.01V3.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.384 9.489 5.31 11.392-1.46.618-1.059-2.273h-5.583l-1.06 2.273-1.458-.618zM15.3 17.704l2.083-4.468 2.082 4.468z",
    clipRule: "evenodd"
  }));
};
export var ChangeLanguage = function ChangeLanguage(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ChangeLanguageSvg
  }));
};